module.exports = __webpack_public_path__ + "static/img-1-desktop-ccd165021dcad2863ccc88f913d2dcad.jpg";